var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 239,
    viewBox: "0 0 229 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5530_3722",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 228,
    height: 230
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228 0H0V230H228V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5530_3722)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M114 230C176.96 230 227.99 178.51 227.99 115C227.99 51.49 176.96 0 114 0C51.04 0 0 51.49 0 115C0 178.51 51.04 229.99 114 229.99V230Z",
    fill: "#FFB70A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M208.52 115C208.52 147.92 191.98 176.95 166.83 194.08C151.75 204.36 133.57 210.36 114 210.36C77.9605 210.36 46.6305 190.01 30.6905 160.08C23.5305 146.66 19.4805 131.31 19.4805 115.01C19.4805 62.3502 61.8005 19.6602 114 19.6602C166.2 19.6602 208.52 62.3502 208.52 115.01V115Z",
    fill: "#FFB70A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5530_3722",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 19,
    width: 190,
    height: 192
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M208.52 115C208.52 147.92 191.98 176.95 166.83 194.08C151.75 204.36 133.57 210.36 114 210.36C77.9605 210.36 46.6305 190.01 30.6905 160.08C23.5305 146.66 19.4805 131.31 19.4805 115.01C19.4805 62.3502 61.8005 19.6602 114 19.6602C166.2 19.6602 208.52 62.3502 208.52 115.01V115Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5530_3722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.801 121.58C167.631 129.93 166.451 138.28 165.281 146.63C161.921 170.6 158.551 194.57 155.191 218.55C154.711 221.96 154.231 225.38 153.751 228.79C153.011 234.12 148.341 238.1 142.831 238.1H87.6414C82.1814 238.1 77.5514 234.2 76.7314 228.93C76.2014 225.5 75.6714 222.06 75.1414 218.63C71.4514 194.64 67.7514 170.65 64.0514 146.66C62.7714 138.35 61.4914 130.03 60.2114 121.72C59.2014 115.2 64.3714 109.34 71.1114 109.34H157.871C164.561 109.34 169.711 115.11 168.801 121.58Z",
    fill: "#72B62F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.281 146.629C161.921 170.599 158.551 194.569 155.191 218.549C153.761 217.549 152.931 215.799 153.171 213.949L161.631 150.689C161.901 148.659 163.401 147.089 165.281 146.629Z",
    fill: "#56921A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1408 218.63C71.4508 194.64 67.7508 170.65 64.0508 146.66C65.9908 147.05 67.5808 148.62 67.8808 150.68L77.3708 213.8C77.6708 215.76 76.7308 217.63 75.1408 218.63Z",
    fill: "#56921A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.629 92.6271C139.293 87.299 162.051 80.4046 161.461 77.2282C160.87 74.0517 137.155 75.796 108.491 81.1241C79.8267 86.4522 57.0685 93.3465 57.6589 96.523C58.2494 99.6994 81.9649 97.9552 110.629 92.6271Z",
    fill: "#39680B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.741 79.06C143.961 79.49 126.821 80.99 107.991 84.52C89.9409 87.91 74.0209 92.45 60.5009 97.17C58.1709 97.98 55.6809 96.53 55.2309 94.11C54.9309 92.46 54.6209 90.8 54.3209 89.16C53.9509 87.19 55.1009 85.24 57.0109 84.62C65.3809 81.84 74.5209 79.14 84.4109 76.69C86.9709 76.05 89.5909 75.42 92.2509 74.83C96.3709 73.9 100.591 73.03 104.931 72.2C112.111 70.84 119.051 69.76 125.751 68.87C128.511 68.51 131.221 68.18 133.891 67.9C142.231 66.98 150.121 66.41 157.521 66.09C159.521 66 161.291 67.41 161.661 69.38C161.961 71.03 162.271 72.68 162.571 74.33C163.021 76.75 161.201 78.99 158.741 79.07V79.06Z",
    fill: "#72B62F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.661 123C143.17 123 166.281 118.899 166.281 113.84C166.281 108.781 143.17 104.68 114.661 104.68C86.1521 104.68 63.041 108.781 63.041 113.84C63.041 118.899 86.1521 123 114.661 123Z",
    fill: "#39680B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.891 67.8896C131.221 68.1696 128.511 68.4996 125.751 68.8596L124.521 66.3896C123.451 64.2696 121.491 62.8696 119.351 62.7496C115.281 62.4996 110.291 62.6896 104.771 63.9696C101.571 64.6996 98.7206 65.6696 96.2406 66.7096C94.2106 67.5796 92.7906 69.6096 92.5306 72.0496C92.4406 72.9796 92.3406 73.8996 92.2506 74.8196C89.5906 75.4196 86.9706 76.0496 84.4106 76.6796C84.2906 75.8196 84.2706 74.9296 84.3606 74.0196C84.5806 71.8996 84.8006 69.7896 85.0106 67.6796C85.3606 64.2296 87.3606 61.3696 90.2306 60.1796C93.7106 58.6996 97.7206 57.3296 102.231 56.2996C110.001 54.5196 117.031 54.2596 122.761 54.5896C125.771 54.7696 128.521 56.7296 130.021 59.7296L133.191 66.0796C133.491 66.6696 133.721 67.2796 133.901 67.8896H133.891Z",
    fill: "#56921A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3982 150.682C92 148.033 89.5299 146.209 86.8811 146.607C84.2322 147.005 82.4078 149.475 82.806 152.124L92.2958 215.245C92.694 217.894 95.1641 219.718 97.8129 219.32C100.462 218.922 102.286 216.452 101.888 213.803L92.3982 150.682Z",
    fill: "#56921A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.196 151.986C145.551 149.331 143.687 146.891 141.032 146.536C138.377 146.181 135.937 148.045 135.581 150.7L127.117 213.966C126.762 216.621 128.627 219.061 131.282 219.416C133.936 219.772 136.377 217.907 136.732 215.252L145.196 151.986Z",
    fill: "#56921A"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M202.548 40C207.601 40 212.54 41.4984 216.742 44.3056C220.943 47.1128 224.217 51.1029 226.151 55.7711C228.085 60.4394 228.591 65.5762 227.605 70.532C226.619 75.4878 224.186 80.04 220.613 83.6129C217.04 87.1859 212.488 89.6191 207.532 90.6048C202.576 91.5906 197.439 91.0847 192.771 89.151C188.103 87.2173 184.113 83.9428 181.306 79.7415C178.498 75.5402 177 70.6008 177 65.5479C176.996 62.1916 177.653 58.8674 178.936 55.7658C180.218 52.6642 182.1 49.846 184.473 47.4728C186.846 45.0996 189.664 43.2179 192.766 41.9356C195.867 40.6533 199.192 39.9955 202.548 40Z",
    fill: "#F84842"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.081 73.5262L198.082 73.5267C199.66 74.4374 201.677 73.897 202.588 72.3194L213.668 53.1281C214.578 51.5506 214.038 49.5334 212.46 48.6227L212.46 48.6222C210.882 47.7115 208.865 48.252 207.954 49.8295L196.874 69.0208C195.963 70.5983 196.504 72.6155 198.081 73.5262Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194.942 82.9186C197.127 82.9186 198.899 81.1469 198.899 78.9613C198.899 76.7757 197.127 75.0039 194.942 75.0039C192.756 75.0039 190.984 76.7757 190.984 78.9613C190.984 81.1469 192.756 82.9186 194.942 82.9186Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0463fd5e8bc5983db5b9d56e80fdb3ae.svg";
export { ForwardRef as ReactComponent };